import { render, staticRenderFns } from "./SupportRequestIssueList.vue?vue&type=template&id=6c071512&"
import script from "./SupportRequestIssueList.vue?vue&type=script&lang=js&"
export * from "./SupportRequestIssueList.vue?vue&type=script&lang=js&"
import style0 from "./SupportRequestIssueList.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports